import Cookies from 'universal-cookie'
import dayjs from 'dayjs'
const cookies = new Cookies()

const PREFIX_COOKIE_BANNER = 'shp_www_banner'
export const getCookie = (cookieName) => {
  try {
    return cookies.get(cookieName)
  } catch {
    return ''
  }
}

export const setCookie = (cookieName, cookieValue, options = {}) => {
  const DEFAULT_OPTION = { path: '/' }
  cookies.set(cookieName, cookieValue, {
    ...DEFAULT_OPTION,
    ...options,
  })
}

export const removeCookie = (cookieName) => {
  const DEFAULT_OPTION = { path: '/' }
  cookies.remove(cookieName, DEFAULT_OPTION)
}

const genrateCookies = (positionId) => {
  const cookieName = `${PREFIX_COOKIE_BANNER}_${positionId}`
  return cookieName
}

export const getCookieBanner = (positionId) => {
  const cookieName = genrateCookies(positionId)
  const result = getCookie(cookieName)
  return result
}
export const setCookieBanner = (positionId, cookieValue, options = {}) => {
  const nowDate = dayjs()
  const expiredDate = dayjs().add(12, 'hour')

  const nextHalfDayInSecond = expiredDate.diff(nowDate, 'second')
  const DEFAULT_OPTION = { path: '/', maxAge: nextHalfDayInSecond }

  const cookieName = genrateCookies(positionId)

  cookies.set(cookieName, cookieValue, {
    ...DEFAULT_OPTION,
    ...options,
  })
}
